import { render, staticRenderFns } from "./Ecosystem.vue?vue&type=template&id=2c46246c&scoped=true&"
import script from "./Ecosystem.vue?vue&type=script&lang=js&"
export * from "./Ecosystem.vue?vue&type=script&lang=js&"
import style0 from "./Ecosystem.vue?vue&type=style&index=0&id=2c46246c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c46246c",
  null
  
)

export default component.exports